// workflow constants
export const EPCS_WORKFLOW = 'EPCS';
export const EPCSAPPROVAL_WORKFLOW = 'EPCSAPPROVAL';
export const SECONDFACTORONLY_WORKFLOW = 'SECONDFACTORONLY';
export const EPNONCS_WORKFLOW = 'EPNONCS';
export const DUALSIGNOFF_WORKFLOW = 'DUALSIGNOFF';
export const STRONGUSERVERIFICATION_WORKFLOW = 'STRONGUSERVERIFICATION';
export const USERVERIFICATION_WORKFLOW = 'USERVERIFICATION';
export const HELPDESKVERIFICATION_WORKFLOW = 'HELPDESKVERIFICATION';
export const SELFSERVICE_PWDRESET_CAUI = 'SELFSERVICE_PWDRESET_CAUI';
export const WEBSSO_WORKFLOW = 'WEBSSO';

// ACR constants
export const KNOWLEDGE_ACR_VALUE = 'knowledge';
export const POSSESSION_ACR_VALUE = 'possession';
export const INHERENCE_ACR_VALUE = 'inherence';
export const POSSESSION_OR_INHERENCE_ACR_VALUE = 'possessionorinherence';
export const KNOWLEDGE_OR_POSSESSION_ACR_VALUE = 'knowledgeorpossession';
export const KNOWLEDGE_OR_INHERENCE_ACR_VALUE = 'knowledgeorinherence';
export const KNOWLEDGE_OR_POSSESSION_OR_INHERENCE_ACR_VALUE = 'knowledgeorpossessionorinherence';

// Single source of truth for modality ordering (lower value = higher priority).
// Used both by the choose-modality screen to sort the displayed options and by
// the no-camera fallback to pick the preferred modality to switch to.
export const MODALITY_ORDER = {
  face: 1,
  proxcard: 2,
  password: 3,
  pin: 4,
  iid: 5,
  sms: 6,
  tempcode: 7,
  otp: 8,
  email: 9,
  idv: 10,
  helpDesk: 11,
  unknown: 12,
};

// Returns the order/priority of a modality. Unmapped modalities use the
// 'unknown' order so they sort last.
export function getModalityOrder(modality) {
  const order = MODALITY_ORDER[modality];
  return typeof order === 'number' ? order : MODALITY_ORDER.unknown;
}
